import { Navigate } from 'react-router-dom';
import { useAuthSession } from 'hooks/useAuthSession';
import { getRootRedirect } from 'utils/authNavigation';

/**
 * Guards routes by role to prevent direct URL access bypassing menu visibility.
 */
export default function RoleRoute({ allowedRoles = [], children }) {
  const session = useAuthSession();
  const role = session?.user?.role;

  if (!session.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!session.isSessionComplete) {
    return <Navigate to={getRootRedirect(session)} replace />;
  }

  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return children;
  }

  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to="/forbidden" replace />;
  }

  return children;
}
